import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URLS, PLATFORM_TYPE } from "../../constants/constants";

export const otpserviceApi = createApi({
  reducerPath: "otpserviceApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URLS.USERMANAGEMENT_BASE_URL,
    prepareHeaders: (headers) => {
      headers.set("PLATFORM-TYPE", PLATFORM_TYPE);
      return headers;
    },
     }),
    keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    
    sendotp: builder.mutation({
      query: (data) => ({
        url: `api/v1/etpbms-user-management/otp/send`,
        method: "POST",
       body: data,
        headers: {
          // "atkn_bnd": localStorage?.atkn_bnd,
          // "rtkn_bnd": localStorage?.rtkn_bnd,
          // "channelidobo": "ETPBMS",      
        },
      }),
    }),

    verifyotp: builder.mutation({
      query: (data) => ({
        url: `api/v1/etpbms-user-management/otp/verify`,
        method: "POST",
       body: data,
        headers: {
          // "atkn_bnd": localStorage?.atkn_bnd,
          // "rtkn_bnd": localStorage?.rtkn_bnd,
          // "channelidobo": "ETPBMS",      
        },
      }),
    }),
    eciForgotPassword: builder.mutation({
      query: (data) => ({
        url: `api/v1/etpbms-user-management/forgot/password`,
        method: "POST",
        body: data,
        headers: {
            "Content-Type": "application/json",
            "atkn_bnd": localStorage?.atkn_bnd,
            "rtkn_bnd": localStorage?.rtkn_bnd,
            "channelidobo": "ETPBMS",      
        },
      }),
    }),
    getUserName: builder.query({
      query: (data) => ({
        url: `api/v1/etpbms-user-management/getLoginUser`,
        method: "GET",
        headers: {
          "Authorization":'Bearer ' + localStorage?.access_token,
          "currentRole":localStorage?.userrole,
          "atkn_bnd": localStorage?.atkn_bnd,
          "rtkn_bnd": localStorage?.rtkn_bnd,
          "channelidobo": "ETPBMS",      
        },
      }),
    }),
  }),
});
export const {
  useSendotpMutation,
  useVerifyotpMutation,
  useEciForgotPasswordMutation,
  useGetUserNameQuery
} = otpserviceApi;
